// src/util/subdomain.js

/**
 * Resolve org subdomain for both prod & dev.
 *
 * Usage:
 *  - getSubdomain()                            // uses window.location.*
 *  - getSubdomain(hostname, search)           // explicit host/search
 *
 * In dev on localhost, you can simulate a portal with:
 *   http://localhost:3000/?org=demo
 */
export function getSubdomain(hostname, search) {
    if (typeof window !== "undefined") {
        if (!hostname) hostname = window.location.hostname;
        if (!search) search = window.location.search;
    }

    hostname = hostname || "";
    search = search || "";

    const host = hostname.toLowerCase();

    const isPortalDomain =
        host.endsWith(".kbolasports.com") ||
        host.endsWith(".angeonx.com");

    if (isPortalDomain) {
        const parts = host.split(".");
        if (parts.length >= 3) {
            const sub = parts[0];
            if (!["www", "api", "sports", "ml"].includes(sub)) return sub;
        }
        return null;
    }

    // Dev-only helper
    if (host === "localhost" || host === "127.0.0.1") {
        try {
            const params = new URLSearchParams(search);
            const devOrg = params.get("org");
            return devOrg ? devOrg.toLowerCase() : null;
        } catch {
            return null;
        }
    }

    return null;
}
